import { Item } from '../../common/snippets'
import { AcountingHeading } from './common/AcountingHeading'
import { Box, Button } from '@mui/material'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './common/AcountingId'
import * as lb from './common/AcountingLables'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import { useEffect, useState } from 'react'
import moment from 'moment'
import { focusElemnt, isEmpty } from '../../common/helper'
import useToken from '../../helpers/useTokens'
import { TableComponent } from '../../common/TableComponent'
import { BookingSummaryHeaders, criteriaHeaders } from './contants'
import { GetRequest } from '../../common/api'
import { urls } from '../../common/constants'
import { useAtom, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { accumulateTotals } from '../Reports/NonMovementTable/utilFucntions'
import { CargoRoleRightsAtom } from '../../common/jotaiState/commonStateAtoms'
const reportName = 'Booking Summary Report'
export const BookingSummary = () => {
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const { loginData } = useToken()
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  const { AllowViewAllBranchReport, AllowBranchInchargeRights } = { ...roleRightsData }
  const { IsBranchAdmin, IsMTPLAdmin, IsAdmin } = loginData
  const [disableBtn, setDisableBtn] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [stateList, setStateList] = useState([])
  const [selState, setSelState] = useState()
  const [cityList, setCityList] = useState([])
  const [filterdCityList, setFilterdCityList] = useState([])
  const [selCity, setSelCity] = useState()
  const [branchList, setBranchList] = useState([])
  const [filterdBranchList, setFilterdBranchList] = useState([])
  const [selBranch, setSelBranch] = useState()
  const [tableData, setTableData] = useState([])
  const headers = BookingSummaryHeaders.map((col) => ({
    ...col,
    align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
    exportHead: col.header,
  }))
  useEffect(() => {
      if (!isEmpty(cargoRoleRights) && !isEmpty(loginData)) {
        setDisableBtn(!(AllowViewAllBranchReport || AllowBranchInchargeRights || IsBranchAdmin || IsMTPLAdmin || IsAdmin))
      }
    }, [cargoRoleRights, loginData])
  const fetchFilters = () => {
    setLoader(true)
    const data = {
      intCompanyID: loginData.intCompanyID,
      FromDate: fromDate.format('YYYY-MM-DD'),
      ToDate: toDate.format('YYYY-MM-DD'),
      intCityID: 0,
      intBranchID: 0,
    }
    GetRequest(urls.bookingSummaryPreprocessData, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }
        const raw = res.Data.Table
        // ================= STATE LIST =================
        let states = [
          ...new Map(
            raw.map((r) => [
              Number(r.StateID),
              { StateID: Number(r.StateID), StateName: r.StateName.trim() },
            ])
          ).values(),
        ]

        if (states.length > 1) {
          states = [{ StateID: 0, StateName: 'All' }, ...states]
        }

        setStateList(states)

        // ================= CITY LIST =================
        let cities = [
          ...new Map(
            raw.map((r) => [
              Number(r.CityID),
              {
                StateID: Number(r.StateID),
                CityID: Number(r.CityID),
                CityName: r.CityName.trim(),
              },
            ])
          ).values(),
        ]

        setCityList(cities)

        // ================= BRANCH LIST =================
        let branches = [
          ...new Map(
            raw.map((r) => [
              Number(r.BranchID),
              {
                StateID: Number(r.StateID),
                CityID: Number(r.CityID),
                BranchID: Number(r.BranchID),
                BranchName: r.BranchName.trim(),
              },
            ])
          ).values(),
        ]
        setBranchList(branches)
        const loginBranchID = Number(loginData.intBranchID)

        // Step 1: Find branch from raw data
        const loginBranchData = raw.find(
          (r) => Number(r.BranchID) === loginBranchID
        )

        if (!loginBranchData) {
          console.log('Login branch not found in API data')
          return
        }

        const loginCityID = Number(loginBranchData.CityID)
        const loginStateID = Number(loginBranchData.StateID)

        // ================= SELECT STATE =================
        const selectedState = states.find((s) => s.StateID === loginStateID) || states[0]
        const filteredCities = cities.filter((c) => c.StateID === selectedState.StateID)
        const finalCities = filteredCities.length > 1 ? [{ CityID: 0, CityName: 'All' }, ...filteredCities] : filteredCities
        const selectedCity = finalCities.find((c) => c.CityID === loginCityID) || finalCities[0]

        const filteredBranches = branches.filter((b) => b.CityID === selectedCity.CityID)

        const finalBranches = filteredBranches.length > 1 ? [{ BranchID: 0, BranchName: 'All' }, ...filteredBranches] : filteredBranches

        const selectedBranch = finalBranches.find((b) => b.BranchID === loginBranchID) || finalBranches[0]

        // ================= SET STATE =================
        setFilterdCityList(finalCities)
        setFilterdBranchList(finalBranches)

        setSelState(selectedState)
        setSelCity(selectedCity)
        setSelBranch(selectedBranch)
      })
      .catch((err) => {
        setAlert({
          show: true,
          msg: err.message,
          nextId: '',
        })
      })
      .finally(() => setLoader(false))
  }
  const fetchTableData = () => {
    const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
    if ( diffDays > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
      return
    } else if (!selState?.StateName || !selCity?.CityName || !selBranch?.BranchName) {
      setAlert({ show: true, msg: 'Please select state, city and branch', nextId: '' })
      return
    }
    setLoader(true)
    const data = {
      intCompanyID: loginData.intCompanyID,
      FromDate: fromDate.format('YYYY-MM-DD'),
      ToDate: toDate.format('YYYY-MM-DD'),
      intCityID: selCity.CityID,
      intBranchID: selBranch.BranchID,
    }
    GetRequest(urls.bookingSummaryPreprocessData, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table1) || res.Data.Table1.length === 0) {
          throw new Error('No Data Found')
        }
        const data = formatTableData(res.Data.Table1)
        const reportPayload = {
          reportName,
          criteriaHeaders,
          criteriaData: [criteriaData],
          tableData: data,
          mainHeader: headers,
          serialNokey :'SN',
        }

      const rid = Date.now().toString()

        if (!window.generatedReports) {
          window.generatedReports = {}
        }

        window.generatedReports[rid] = reportPayload

        window.open(`/view-report?rid=${rid}`, "_blank")
        // setTableData(data)
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const formatTableData = (list) => {
    list = list.map((col, index) => ({
      ...col,
      dataType: 'entry',
      SN: index + 1,
      disabled: true,
      BookingDate: moment(col.BookingDate).format('DD-MM-YYYY'),
    }))
    const grouped = list.reduce((map, curr) => {
      const key = curr.BookingDate
      if (!map.has(key)) {
        map.set(key, [])
      }
      map.get(key).push(curr)
      return map
    }, new Map())

    const numericKeys = BookingSummaryHeaders.reduce((acc, curr) => {
      if (curr.xlCol.dataType === 'quantity') {
        acc.push(curr.field?.replace(/_view$/, ''))
      }
      return acc
    }, [])
    const formatted = Array.from(grouped.entries()).flatMap(([transDate, items]) => {
      const groupTotal = accumulateTotals(items, numericKeys)
      return [
        ...items,
        {
          dataType: 'total',
          [BookingSummaryHeaders[0].field]: `TOTAL: ${transDate}`,
          align: { [BookingSummaryHeaders[0].field]: 'right' },
          colSpan: { [BookingSummaryHeaders[0].field]: 5 },
          ...groupTotal,
        },
      ]
    })
    if (grouped.length > 1) {
      const grandTotal = accumulateTotals(
        formatted.filter((row) => row.dataType === 'entry'),
        numericKeys
      )

      formatted.push({
        dataType: 'total',
        [BookingSummaryHeaders[0].field]: `TOTAL: ${fromDate.format('DD-MM-YYYY')} to ${toDate.format('DD-MM-YYYY')}`,
        align: { [BookingSummaryHeaders[0].field]: 'right' },
        colSpan: { [BookingSummaryHeaders[0].field]: 5 },
        ...grandTotal,
      })
    }
    return formatted
  }

  const criteriaData = {
    fromDate: fromDate.format('DD-MM-YYYY'),
    toDate: toDate.format('DD-MM-YYYY'),
    selState: selState?.StateName,
    selCity: selCity?.CityName,
    selBranch: selBranch?.BranchName,
    dataType: 'entry',
  }
  const handleStateChange = (val) => {
    setSelState(val)
    const stateCities = val.StateID === 0 ? cityList : cityList.filter((city) => city.StateID === val.StateID)
    if (stateCities.length > 1 && val.StateID !== 0) {
      stateCities.unshift({ CityName: 'All', CityID: 0 })
    }
    setFilterdCityList(stateCities)
    setSelCity(stateCities[0])
    const cityBranches =
      val.StateID === 0
        ? branchList
        : stateCities[0].CityID === 0
          ? branchList.filter((branch) => branch.StateID === val.StateID)
          : branchList.filter((branch) => branch.CityID === stateCities[0].CityID)
    if (cityBranches.length > 1 && val.StateID !== 0) {
      cityBranches.unshift({ BranchName: 'All', BranchID: 0 })
    }
    setFilterdBranchList(cityBranches)
    setSelBranch(cityBranches[0])
  }
  const handleCityChange = (val) => {
    setSelCity(val)

    const cityBranches =
      val.CityID === 0
        ? selState.StateID === 0
          ? branchList
          : branchList.filter((branch) => branch.StateID === selState.StateID)
        : branchList.filter((branch) => branch.CityID === val.CityID)
    if (cityBranches.length > 1 && (val.CityID !== 0 || selState.StateID !== 0)) {
      cityBranches.unshift({ BranchName: 'All', BranchID: 0 })
    }
    setFilterdBranchList(cityBranches)
    setSelBranch(cityBranches[0])
  }
  return (
    <Item sx={{ padding: '0' }} className="reports">
      <AcountingHeading reportName={reportName.slice(0, -7)} />
      <Box sx={sx.reportFlex}>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.selectCompany}
            label={lb.select_company}
            defaultvalue={loginData.strCompanyName}
            disabled={true}
            minWidth="250px"
          />
        </Item>

        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={`From Date`}
            name={'from_date'}
            id={id.fromDate}
            value={fromDate}
            dateChange={(date) => {
              setFromDate(date)
              focusElemnt(id.toDate)
            }}
            width="210px"
          />
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={'To Date'}
            name={'to_date'}
            id={id.toDate}
            value={toDate}
            dateChange={(date) => {
              setToDate(date)
              focusElemnt('buttonGo')
            }}
            width="210px"
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button
            id="buttonGo"
            onClick={fetchFilters}
            variant="contained"
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
          >
            GO
          </Button>
        </Item>

        <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.stateId}
            label={lb.selectState}
            data={stateList}
            defaultvalue={selState?.StateName || ''}
            value={selState?.StateName || ''}
            idKey={`StateID`}
            dataKey={`StateName`}
            onSelect={handleStateChange}
            searchPlaceholder={`Search State`}
            width="200px"
            nextId={id.srcCity}
            prevId={'buttonGo'}
            disabled={disableBtn}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.srcCity}
            label={lb.selectCity}
            data={filterdCityList}
            defaultvalue={selCity?.CityName || ''}
            value={selCity?.CityName || ''}
            idKey={`CityID`}
            dataKey={`CityName`}
            onSelect={handleCityChange}
            searchPlaceholder={`Search City`}
            width="250px"
            nextId={id.selectBranches}
            prevId={id.stateId}
            disabled={disableBtn}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.selectBranches}
            label={lb.selectBranches}
            data={filterdBranchList}
            defaultvalue={selBranch?.BranchName || ''}
            value={selBranch?.BranchName || ''}
            idKey={`BranchID`}
            dataKey={`BranchName`}
            onSelect={(val) => {
              setSelBranch(val)
            }}
            searchPlaceholder={`Search Branches`}
            width="240px"
            nextId={'buttonLoad'}
            prevId={id.srcCity}
            disabled={disableBtn}
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button
            id="buttonLoad"
            onClick={fetchTableData}
            variant="contained"
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
          >
            Load
          </Button>
        </Item>
      </Box>
      {/* {tableData.length ? (
        <TableComponent
          reportName={reportName}
          criteriaHeaders={criteriaHeaders}
          criteriaData={[criteriaData]}
          tableData={tableData}
          mainHeader={headers}
        />
      ) : (
        <></>
      )} */}
    </Item>
  )
}
